export default "__VITE_ASSET__DAKVlrUD__"